export const enGB = {
    price: 'Price',
    apply: 'Apply',
    filterFor: 'Filter for',
    default: 'Default',
    alphabetic: 'Alphabetic',
    newest: 'Latest arrivals',
    popularity: 'Popularity',
    priceHighToLow: 'Price: high to low',
    priceLowToHigh: 'Price: low to high',
    showMore: 'Show more',
    showPrev: 'Show previous',
    noProductsFound: 'No products found',
    from: 'from',
    outOfStock: 'Out of stock',
    addToCart: 'Add to cart',
    addProductToCart: 'Add {0} to cart',
    showProduct: 'Show more',
};
export default enGB;
